// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__miWNG","footerContainer":"Footer_footerContainer__kU1CX","footerRow":"Footer_footerRow__BBkh1","logo":"Footer_logo__1W0Kt"};